import { ValidationResult, ValidationError, RequiredFieldCheck } from '@/views/helpers/validation-result';
import ValidationMessages from '@/views/helpers/validation-messages';
import { ReportOfSickness } from '@/resources/models/reports-of-sickness';
import DisabilityRate from '@/views/validations/disability-rate';
import ValidationCodes from '@/views/helpers/validation-codes';

export default {
  validate (period, reportOfSickness, originalPeriod) {
    let validationResult = new ValidationResult();

    validationResult.push(DisabilityRate.validateDisabilityRateFormat(period.disabilityRate));
    validationResult.push(DisabilityRate.validateDisabilityRateMinimum(period.disabilityRate));
    validationResult.push(DisabilityRate.validateDisabilityRateMaximum(period.disabilityRate));
    validationResult.push(this.validateAnyChanges(period, originalPeriod));

    let _r = new ReportOfSickness(reportOfSickness.getApiData());
    _r.periods = reportOfSickness.periods.filter(p => p.id !== period.id);

    validationResult.push(DisabilityRate.validatePreviousDisabilityRateIsNotTheSame(_r, period.disabilityRate));

    return validationResult;
  },

  requiredFields (period) {
    let validationResult = new ValidationResult();

    validationResult.push(RequiredFieldCheck('startDate', period.startDate));
    validationResult.push(RequiredFieldCheck('disabilityRate', period.disabilityRate));

    return validationResult;
  },

  validateAnyChanges (period, originalPeriod) {
    if (period.startDate === originalPeriod.startDate && period.disabilityRate === originalPeriod.disabilityRate) {
      return new ValidationError({
        message: ValidationMessages.Period.NO_VALUE_WAS_CHANGED,
        attribute: 'period',
        code: ValidationCodes.NO_CHANGES
      });
    }
  }
};
